import { Subject } from 'rxjs';

export interface NotificationData {
  type: string;
  message: string;
  fullMessage?: string;
  isExpandable?: boolean;
}

const subject = new Subject<NotificationData>();
// Minimal sequential queue so toasts do not overwrite each other
const queue: NotificationData[] = [];
let isProcessing = false;
const DISPLAY_MS = 4500; // slightly above Toast visibilityTime

function enqueueAndProcess(item: NotificationData) {
  queue.push(item);
  if (!isProcessing) {
    processQueue();
  }
}

function processQueue() {
  if (isProcessing) return;
  const next = queue.shift();
  if (!next) return;
  isProcessing = true;
  subject.next(next);
  // After the toast display window, allow next item
  setTimeout(() => {
    isProcessing = false;
    processQueue();
  }, DISPLAY_MS);
}

export const notificationService = {
    sendNotification: (type: string, message: string, fullMessage?: string) => {
        const isExpandable = fullMessage ? true : (message.length > 150);
        const displayMessage = isExpandable && !fullMessage ? 
            message.substring(0, 147) + '...' : message;
        
        // console.log('NotificationService sending:', {
        //     type,
        //     originalLength: message.length,
        //     isExpandable,
        //     displayMessage,
        //     fullMessage: fullMessage || message
        // });
        
        enqueueAndProcess({
            type,
            message: displayMessage,
            fullMessage: fullMessage || message,
            isExpandable,
        });
    },
    getNotification: () => subject.asObservable(),
    clearNotification: () => subject.next({type: 'default', message: '', isExpandable: false})
}